import { ChipField, DateField, List as RaList, TextField } from "react-admin";
import { Datagrid, LongTextField } from "ra-friendsofbabba";

import Filters from "./Filters";
import React from "react";

const List = (props) => (
  <RaList
    {...props}
    perPage={25}
    filters={<Filters />}
    sort={{ field: "id", order: "DESC" }}
  >
    <Datagrid {...props}>
      <TextField source="id" label="ID" />
      <ChipField source="type" />
      <LongTextField source="message" variant="body2" />
      <DateField source="created" showTime />
    </Datagrid>
  </RaList>
);

export default List;
